import React, {useState, Fragment, useCallback,useEffect} from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Media,  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { stafftabledata, tableColumns } from '../../../Data/Staff';
import { useNavigate } from 'react-router';
import { Navigator } from '../../../Data/Table/Defaultdata';
import { DeleteStaff, StaffList } from '../../../apiController';
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

import { roles_permissions } from '../../../Layout/Sidebar/Menu';

const StaffIndex = () =>{

  const permission = roles_permissions.find(
    (role) => role.module_name === 'Staff'
  );

  const navigate = useNavigate()
  const [searchKeyword, setSearchKeyword] = useState('');
  const [staff, setStaff] = useState([]);
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const clearSearchTab = () => {
    setSearchKeyword("");
};

const searchedStaff = staff
        .filter(
            (c) =>
                (c.aadhar_number?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
                (c.qualification?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
                (c.gender?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
                (c.employee_number?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
                (c.staff_category?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
                (`${c.first_name} ${c.surname}`.toLowerCase() ?? "").includes(
                    searchKeyword.toLowerCase()
                ) ||
                (c.phone ?? "").includes(searchKeyword.toLowerCase()) ||
                c.gender?.toLowerCase() === searchKeyword.toLowerCase() ||
                (c.patient_reg_no ?? "").includes(searchKeyword.toLowerCase())
        )
        .reverse();

  const stafftabledata = searchedStaff.map(((row, ind)=>(
    {
        ind: ind+1,
        id: row.id,
        name: 
        // <Media className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: `${user1}`, alt: 'Generic placeholder image' }} /> {`${row.first_name} ${row.surname}`}
            <Media body className="align-self-center">
                <div className="f-w-700 font-success"> {row.first_name + ' ' + row.surname}</div>
            </Media>,
        // {/* </Media>, */}
        // date: '2023/04/27',
        emyployeeId:  <span> {row.employee_number} <i className="fa fa-pencil"></i></span>,
        role: row.staff_category,
        qualification: row.qualification,
        aadharnumber: row.aadhar_number,
        contactnumber: <span className="f-w-700"><i className="icofont"></i> {row.phone}</span>,
        action: <span>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Edit </Btn> */}
        <Navigator to={`${process.env.PUBLIC_URL}/staffForm/:layout`} params={{ rowData: row , btn: "edit"}}/>
      </span>
        // budget: '$3142.00',

    })
  )
)

 const tableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: false,
    },
    {
        name: 'Name',
        selector: row => row['name'],
        sortable: true,
        center: false,
    },
    // {
    //     name: 'Date',
    //     selector: row => `${row.date}`,
    //     sortable: true,
    //     center: true,
    // },
    {
        name: 'Employee Id',
        selector: row => row['emyployeeId'],
        sortable: true,
        center: true,
    },
    {
      name: 'Role',
      selector: row => `${row.role}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Qualification',
      selector: row => `${row.qualification}`,
      sortable: true,
      center: true,
  },
    {
        name: 'Aadhar Number',
        selector: row => row['aadharnumber'],
        sortable: true,
        center: true,
    },
    {
        name: 'Contact Number',
        selector: row => row['contactnumber'],
        sortable: true,
        center: true,
    },
    
    // {
    //     name: 'Action',
    //     selector: row => row['action'],
    //     sortable: false,
    //     center: true,
    // },
];
if (permission?.edit_access) {
  tableColumns.push({
    name: "Action",
    selector: (row) => row["action"],
    sortable: false,
    center: true,
  });
}

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(stafftabledata);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    // const handleDelete = () => {
    //     if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
    //         setToggleDelet(!toggleDelet);

    //         setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
    //         setSelectedRows('');
    //     }
    // };
    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteStaff(id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchStaff()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };

    const fetchStaff = async () => {
      const response = await StaffList();
      if (response.status === true) {
        setStaff(response.data);
      }
    };

    useEffect(()=>{
      fetchStaff()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Staff' parent='Dashboard' title='staff' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          {/* <H5 className='m-0'>Schedule</H5> */}
          {/* <Fragment>
          <div className="search">
                <Form className="theme-form">
                    <FormGroup className="form-group">
                        <Input
                            className="form-control"
                            type="text"
                            placeholder="search"
                            defaultValue={searchKeyword}
                            onChange={(e) =>
                                handleSearchKeyword(e.target.value)
                            }
                        />
                        <i className="fa fa-search"></i>
                    </FormGroup>
                </Form>
          </div>
          </Fragment> */}
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            value={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
          <span className="input-group-text"
            onClick={() => clearSearchTab()}>
              <i className="fa fa-times" aria-hidden="true"></i>
              </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
{permission?.create_access &&   <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=> navigate(`${process.env.PUBLIC_URL}/staffform/:layout`) }}>+ Add Staff</Btn>
          </div>
          </div>}
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={stafftabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows ={permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default StaffIndex